"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFlyoutDefaultProps = exports.HEADER_PADDING_SMALL_VIEWPORT = exports.HEADER_PADDING_LARGE_VIEWPORT = exports.HEADER_PADDING_IN_HIGH_ZOOM_LEVEL = exports.FlyoutDefaultProps = exports.FlyoutContentDefaultProps = exports.FOOTER_PADDING = exports.FOOTER_GRID_GAP = exports.FLYOUT_TITLE_ID = exports.BODY_PADDING_SMALL_VIEWPORT = exports.BODY_PADDING_LARGE_VIEWPORT = exports.BODY_PADDING_IN_HIGH_ZOOM_LEVEL = void 0;

var _interfaces = require("./interfaces");

var FlyoutDefaultProps = {
  role: 'dialog',
  position: _interfaces.FlyoutPosition.Trailing,
  shouldCloseOnClickOutside: true
};
exports.FlyoutDefaultProps = FlyoutDefaultProps;
var FlyoutContentDefaultProps = {
  maxWidth: 600,
  closeButtonAltText: 'Close flyout'
};
exports.FlyoutContentDefaultProps = FlyoutContentDefaultProps;
var withFlyoutDefaultProps = {
  flyoutPosition: _interfaces.FlyoutPosition.Trailing
};
exports.withFlyoutDefaultProps = withFlyoutDefaultProps;
var BODY_PADDING_LARGE_VIEWPORT = 'S500';
exports.BODY_PADDING_LARGE_VIEWPORT = BODY_PADDING_LARGE_VIEWPORT;
var BODY_PADDING_SMALL_VIEWPORT = 'S300';
exports.BODY_PADDING_SMALL_VIEWPORT = BODY_PADDING_SMALL_VIEWPORT;
var BODY_PADDING_IN_HIGH_ZOOM_LEVEL = 'S200';
exports.BODY_PADDING_IN_HIGH_ZOOM_LEVEL = BODY_PADDING_IN_HIGH_ZOOM_LEVEL;
var HEADER_PADDING_LARGE_VIEWPORT = ['S300', 'S500'];
exports.HEADER_PADDING_LARGE_VIEWPORT = HEADER_PADDING_LARGE_VIEWPORT;
var HEADER_PADDING_SMALL_VIEWPORT = 'S300';
exports.HEADER_PADDING_SMALL_VIEWPORT = HEADER_PADDING_SMALL_VIEWPORT;
var HEADER_PADDING_IN_HIGH_ZOOM_LEVEL = 'S200';
exports.HEADER_PADDING_IN_HIGH_ZOOM_LEVEL = HEADER_PADDING_IN_HIGH_ZOOM_LEVEL;
var FOOTER_GRID_GAP = 'S300';
exports.FOOTER_GRID_GAP = FOOTER_GRID_GAP;
var FOOTER_PADDING = 'S300';
exports.FOOTER_PADDING = FOOTER_PADDING;
var FLYOUT_TITLE_ID = 'stencil-flyout-title';
exports.FLYOUT_TITLE_ID = FLYOUT_TITLE_ID;